module.exports = __webpack_public_path__ + "img/5.3ae43846.jpg";